import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Prerendered (react-snap) pages ship fully-baked static HTML, then hydrate
// against code-split routes whose JS chunk can resolve a tick after hydration
// begins. React handles this gracefully: it keeps the prerendered DOM visible
// and re-hydrates the boundary once the chunk arrives (identical output, no
// flash — verified). React surfaces this as a *recoverable* hydration notice;
// we swallow only those benign notices so the console stays clean, while still
// surfacing any genuinely unexpected error.
const isBenignHydrationError = (error) => {
  const msg = (error && (error.message || String(error))) || "";
  return (
    /#(418|421|422|423|425)/.test(msg) ||
    /hydrat/i.test(msg) ||
    /did not match/i.test(msg)
  );
};

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app, {
    onRecoverableError: (error, errorInfo) => {
      if (isBenignHydrationError(error)) return;
      // eslint-disable-next-line no-console
      console.error(error, errorInfo);
    },
  });
} else {
  ReactDOM.createRoot(container).render(app);
}
